// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockFilledSvg from "@ant-design/icons-svg/es/asn/UnlockFilled";
import AntdIcon from '../components/AntdIcon';

var UnlockFilled = function UnlockFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnlockFilledSvg
  }));
};

UnlockFilled.displayName = 'UnlockFilled';
export default React.forwardRef(UnlockFilled);